export default "__VITE_ASSET__CzBxBwvb__"